/**
 *
 * ParkingType14140 constants
 *
 */

export const GROUND = '4014324833000';
export const UNDERGROUND = '4014324836000';
